export class Constants {
  public static timeoutInSeconds = 60;
}

export const RegExpForParamOrVar = /{.*?}/g;
export const RegExpForTextContent = /{{.*?}}/g;

export const SAFActionMap: {[key: string]: string} = {
  "xbox.userpurchases.list": "getxboxpurchases",
  "xbox.refundrequest.submit": "xboxrefundrequest",
  "office.activation.productkeyv2": "officeproductkeycheck",
  "hardware.repairs.list": "gethardwarerepairs",
  "hardware.repairitems.list": "gethardwarerepairitems",
  "hardware.devices.list": "getdevices",
  "xbox.refundstatus.list": "getxboxrefundstatus",
  "membership.allofficeproducts.list": "getallofficeproducts",
}

export const YodaContextVariablesKey = "YodaContextVariables";